import { render } from "./PerfectView.vue?vue&type=template&id=60713ac9"
const script = {}

import "./PerfectView.vue?vue&type=style&index=0&id=60713ac9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__